var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "35px",
    viewBox: "0 -960 960 960",
    width: "35px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M687.27-52q-58.6 0-100.1-41.25-41.5-41.25-41.5-99.42 0-7 3.33-24.22L284.67-371.33q-19.19 16.23-41.91 25.11-22.73 8.89-49.09 8.89-59.03 0-100.35-41.59Q52-420.51 52-479.92T93.32-581q41.32-41.67 100.35-41.67 26 0 49.27 9.03 23.28 9.04 42.73 24.97l262.33-151q-1-6.33-1.67-13.33-.66-7-.66-13.33 0-58.59 41.56-100.46 41.55-41.88 100.16-41.88t100.11 41.9q41.5 41.89 41.5 100.5 0 58.6-41.42 100.1-41.41 41.5-100.58 41.5-26.88 0-50.61-9.83-23.72-9.83-43.06-26.17l-261 145q2.67 8.59 3.84 17.94 1.16 9.36 1.16 18.04 0 8.69-1 17.52-1 8.84-3.66 16.84l260 147.66q19.35-17.37 43.35-27.52 24.01-10.14 51.44-10.14 59.46 0 100.5 41.45T829-193.22Q829-134 787.44-93T687.27-52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.f55dbe59fcffef0afe5bf74905c6dd8e.svg";
export { ForwardRef as ReactComponent };